import { FC } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Typography } from '@mui/material';
import { Field, FieldProps } from 'formik';

import { Card } from 'src/components';
import { InputBaseField } from 'src/components/common/form/FormInput';
import { Flex } from 'src/components/Flex';
import { DropDown } from 'src/components/FormikComponents'; // Custom dropdown

import SearchTooltip from './SearchTooltip';

interface CancelMerchantSearchProps {
    showValidationError: string | undefined;
    selectedType: 'application' | 'service';
    setSelectedType: (value: string) => void;
}

const CancelMerchantSearch: FC<CancelMerchantSearchProps> = ({
    showValidationError,
    selectedType,
    setSelectedType,
}) => {
    const dropdownOptions = [
        { value: 'application', label: 'Application' },
        { value: 'service', label: 'Service' },
    ];

    return (
        <Card flex={1} gap="24px" padding="16px" borderRadius="8px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Cancellation Details
            </Typography>
            <Typography variant="subtitle1">
                Please choose how you want to cancel the merchant’s service, by Application or
                Service ID.
            </Typography>

            <Flex flexDirection="column" gap="16px" width="50%">
                <DropDown
                    name="cancelType"
                    label="Cancel Application or Service?"
                    placeholder="Cancel Application or Service?"
                    options={dropdownOptions}
                    onChange={(value) => {
                        return setSelectedType(value as string);
                    }}
                />

                {selectedType && (
                    <Flex flexDirection="column" gap="12px">
                        <label
                            htmlFor="idInput"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                        >
                            <Typography fontWeight="600">
                                {selectedType === 'application' ? 'Application ID' : 'Service ID'}
                            </Typography>
                            <SearchTooltip
                                title={
                                    selectedType === 'application'
                                        ? 'The application ID can be retrieved from the original Merchant application by going to ‘In Progress Applications’ or by going to ‘View Merchants’ for an additional service.'
                                        : 'The service ID can be retrieved from the Merchant Dashboard under Services.'
                                }
                                header={
                                    selectedType === 'application' ? 'Application ID' : 'Service ID'
                                }
                            >
                                <HelpOutlineIcon />
                            </SearchTooltip>
                        </label>
                        <Field name="idInput">
                            {({ field, meta }: FieldProps) => {
                                return (
                                    <InputBaseField
                                        {...field}
                                        placeholder={
                                            selectedType === 'application'
                                                ? 'Application ID'
                                                : 'Service ID'
                                        }
                                        style={{ width: '100%' }}
                                        error={meta.touched && Boolean(showValidationError)}
                                    />
                                );
                            }}
                        </Field>
                    </Flex>
                )}
            </Flex>
        </Card>
    );
};

export default CancelMerchantSearch;
